import { Heading, Spinner, Stack, Text } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { withPermission } from '../withPermission';
import { IdentityForm } from './IdentityForm';
import { IncompleteIdentityWarning } from './IncompleteIdentityWarning';

/**
 * One page for the whole identity. It was four, one per group, but most groups are
 * two or three fields, so a sub-sidebar navigated between pages that were mostly
 * empty -- and the email preview was only reachable from one of them.
 */
export const IdentityPage = withPermission('canManageOrganisationSettings', () => {
  const { data, isPending, error } = trpcAdmin.organisation.identity.get.useQuery();

  return (
    <Stack gap={4} p={4}>
      <Stack gap={1}>
        <Heading fontSize="lg" size="xs">
          <Trans>Organisation</Trans>
        </Heading>
        <Text fontSize="sm" color="fg.muted">
          <Trans>
            How this organisation identifies itself. These values are used in the emails it sends
            and in the documents it issues, such as certificates.
          </Trans>
        </Text>
      </Stack>

      {isPending && <Spinner />}
      {error != null && (
        <Text fontSize="sm" color="fg.muted">
          <Trans>Could not load the organisation identity.</Trans>
        </Text>
      )}
      {data != null && (
        <>
          <IncompleteIdentityWarning identity={data} />
          <IdentityForm identity={data} />
        </>
      )}
    </Stack>
  );
});
